var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-joinlib_breadcrumbs pr" }, [
    _vm.showLeft
      ? _c("i", {
          staticClass: "pa z-19 yxt-icon-arrow-left text-center hand",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.scroll("left")
            },
          },
        })
      : _vm._e(),
    _c(
      "ul",
      { ref: "wrap", staticClass: "pa over-hidden nowrap text-8c" },
      _vm._l(_vm.list, function (item, i) {
        return _c(
          "li",
          {
            key: item.id,
            staticClass: "d-in-block",
            on: {
              click: function ($event) {
                return _vm.select(item, i)
              },
            },
          },
          [
            i !== 0
              ? _c("span", { staticClass: "d-in-block v-middle" }, [
                  _vm._v("/"),
                ])
              : _vm._e(),
            _c(
              "label",
              {
                staticClass: "nowrap ellipsis v-middle",
                class: { hand: i !== _vm.list.length - 1 },
              },
              [_vm._v(_vm._s(item.label))]
            ),
          ]
        )
      }),
      0
    ),
    _vm.showRight
      ? _c("i", {
          staticClass: "pa z-19 yxt-icon-arrow-right text-center hand",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.scroll("right")
            },
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }